import { useMemo } from 'react';

import styles from './tag-list.component.module.scss';
import { TagListItem } from './tag-list-item.component';

type Props = {
  tags: {
    key: number;
    name: string;
    isMatched?: boolean;
  }[];
  maxCount?: number;
};

export const TagList = ({ tags, maxCount }: Props) => {
  const list = useMemo(
    () => ((maxCount ?? 0) > 0 ? tags.slice(0, maxCount) : tags),
    [tags, maxCount]
  );

  return (
    <ul className={styles.tagList}>
      {list.map((tag) => (
        <TagListItem
          className={tag.isMatched ? 'match' : undefined}
          data-match={tag.isMatched ? true : undefined}
          key={tag.key}
        >
          {tag.name}
        </TagListItem>
      ))}
    </ul>
  );
};
